import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './Form.module.scss';
import PathContext from '../../context/path';
import StatesContext from '../../context/states';
import IMask from 'imask';
const Form = (props) => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const { vacancyId } = props;
  const { endpoint } = states;
  const refInputs = useRef([]);
  const refPlaceholder = useRef([]);
  const refError = useRef([]);
  const refFileInput = useRef(null);
  const refWrap = useRef(null);
  const refBtn = useRef(null);
  const refFileText = useRef(null);
  const [focusedInput, setFocusedInput] = useState(-1);
  const [fileAdded, setFileAdded] = useState(false);
  const [valid, setValid] = useState(true);
  const [sending, setSending] = useState(false);
  const [utm, setUtm] = useState(null);
  const submitHandler = (e) => {
    e.preventDefault();
    refInputs.current.forEach((element, index) => {
      if (element.dataset.required !== undefined) {
        if (element.value.length === 0) {
          setValid(false);
          element.classList.add(styles.error);
          refError.current[index].classList.add(styles.active);
          return;
        }
      }
    });
    if (refInputs.current[3].value.length < 12) {
      setValid(false);
      refInputs.current[3].classList.add(styles.error);
      return;
    }
    if (!refInputs.current[6].checked) {
      setValid(false);
      refInputs.current[6].classList.add(styles.error);
      return;
    }
    if (valid) {
      refBtn.current.textContent = 'Оправляем...';
      setSending(true);
      const query = `
        mutation${
          refFileInput.current.files[0] !== undefined ? '($file: Upload!)' : ''
        }{
          createVacancyResponse(
            first_name: "${refInputs.current[0].value}"
            last_name: "${refInputs.current[1].value}"
            email: "${refInputs.current[2].value}"
            phone: "${refInputs.current[3].value}"
            resume_link: "${refInputs.current[4].value}"
            ${
              refFileInput.current.files[0] !== undefined ? 'resume: $file' : ''
            }
            comment: "${refInputs.current[5].value}"
            vacancy_id: ${
              vacancyId === null || vacancyId === undefined || vacancyId <= 0
                ? null
                : vacancyId
            }
            utm_str: "${
              utm === null || utm === undefined || utm === '' ? null : utm
            }"
          )
        }
      `;
      // let variables = null;
      // if(refFileInput.current.files[0] !== null){
      //   const formData = new FormData();
      //   console.log(formData);
      //   formData.append('dfsd', 'sdfsd');
      //   formData.append('file', refFileInput.current.files[0]);
      //   console.log(formData);
      //   console.log(formData.file);
      //   variables = {
      //     file: formData
      //   }
      // }
      const formData = new FormData();
      formData.append(
        'operations',
        JSON.stringify({
          query: query,
          variables: {
            file: null,
          },
        })
      );
      formData.append(
        'map',
        JSON.stringify({
          0: ['variables.file'],
        })
      );
      formData.append('0', refFileInput.current.files[0]);
      fetch(`${endpoint}/graphql`, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.data.createVacancyResponse) {
            refBtn.current.textContent = 'Отправлено!';

            if (window.ym) {
              window.ym(
                process.env.REACT_APP_YM_ID,
                'reachGoal',
                'vacancy_form_submit'
              );
              window.ym(
                process.env.REACT_APP_YM_ID,
                'hit',
                '/virtual/form-submit'
              );
            }
          }
        })
        .catch((error) => {
          console.error(error);

          refBtn.current.textContent = 'Ошибка';
        });
    }
    // if(refCheckbox.current[3].value.length < 12){
    //   setValid(false);
    //   refInputs.current[3].classList.add(styles.error);
    // }
  };

  useEffect(() => {
    if (sending) {
      refWrap.current.classList.add(styles.sended);
    }
  }, [sending]);

  function fileHandler(e) {
    setFileAdded(true);
    refFileText.current.textContent = refFileInput.current.files[0].name;
    refFileText.current.style.margin = '0';
    // refFileText.current.style.width = '100%';
  }
  function fileDeleteHandler() {
    setFileAdded(false);
    refFileText.current.textContent = 'прикрепите файл';
    refFileText.current.style.margin = '';
    refFileInput.current.value = '';
    // refFileText.current.style.width = '100%';
  }
  useEffect(() => {
    const inputs = refInputs.current;
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    const utm_source = searchParams.get('utm_source');
    const utm_medium = searchParams.get('utm_medium');
    const utm_campaign = searchParams.get('utm_campaign');
    const utm_content = searchParams.get('utm_content');
    const utm_term = searchParams.get('utm_term');
    let resultUtm = null;
    if (
      utm_source !== null ||
      utm_medium !== null ||
      utm_campaign !== null ||
      utm_content !== null ||
      utm_term !== null
    ) {
      // resultUtm = {
      //   utm_source,
      //   utm_medium,
      //   utm_campaign,
      //   utm_content,
      //   utm_term,
      // };
      // resultUtm = JSON.stringify(resultUtm);
      resultUtm = `${utm_source !== null ? `utm_source=${utm_source}` : ''}${
        utm_medium !== null ? `&utm_medium=${utm_medium}` : ''
      }${utm_campaign !== null ? `&utm_campaign=${utm_campaign}` : ''}${
        utm_content !== null ? `&utm_content=${utm_content}` : ''
      }${utm_term !== null ? `&utm_term=${utm_term}` : ''}`;
    }
    setUtm(resultUtm);
    const focusInput = (index) => {
      setValid(true);
      inputs[index].classList.remove(styles.error);
      if (refError.current[index] !== undefined) {
        refError.current[index].classList.remove(styles.active);
      }
      refPlaceholder.current[index].classList.add(styles.active);
    };
    const blurInput = (index) => {
      if (refInputs.current[index].value.length === 0) {
        refPlaceholder.current[index].classList.remove(styles.active);
      }
    };
    inputs.forEach((element, index) => {
      element.addEventListener('focus', () => {
        focusInput(index);
      });
      element.addEventListener('blur', () => {
        blurInput(index);
      });
    });
    inputs[6].addEventListener('change', () => {
      setValid(true);
      inputs[6].classList.remove(styles.error);
    });
    var phoneMask = IMask(refInputs.current[3], {
      mask: '+{7} (000) 000-00-00',
      prepare: (appended, masked) => {
        if (appended === '8' && masked.value === '') {
          return '';
        }
        return appended;
      },
    });
    // refPlaceholder.current[3].addEventListener('change', maskHandler);
  }, []);

  return (
    <>
      <form className={styles.wrap} onSubmit={submitHandler} ref={refWrap}>
        <label className={styles.label} htmlFor="form-firstname">
          <span
            className={styles.placeholder}
            ref={(element) => (refPlaceholder.current[0] = element)}
          >
            Имя
          </span>
          <input
            type="text"
            className={styles.input}
            data-required
            id="form-firstname"
            name="firstname"
            placeholder=""
            ref={(element) => (refInputs.current[0] = element)}
          />
          <span
            className={styles.errortext}
            ref={(element) => (refError.current[0] = element)}
          >
            Поле обязательное
          </span>
        </label>
        <label className={styles.label} htmlFor="form-secondname">
          <span
            className={styles.placeholder}
            ref={(element) => (refPlaceholder.current[1] = element)}
          >
            Фамилия
          </span>
          <input
            type="text"
            className={styles.input}
            data-required
            id="form-secondname"
            name="secondname"
            placeholder=""
            ref={(element) => (refInputs.current[1] = element)}
          />
          <span
            className={styles.errortext}
            ref={(element) => (refError.current[1] = element)}
          >
            Поле обязательное
          </span>
        </label>
        <label className={styles.label} htmlFor="form-mail">
          <span
            className={styles.placeholder}
            ref={(element) => (refPlaceholder.current[2] = element)}
          >
            Почта
          </span>
          <input
            type="email"
            className={styles.input}
            data-required
            id="form-mail"
            name="mail"
            placeholder=""
            ref={(element) => (refInputs.current[2] = element)}
          />
          <span
            className={styles.errortext}
            ref={(element) => (refError.current[2] = element)}
          >
            Поле обязательное
          </span>
        </label>
        <label className={styles.label} htmlFor="form-tel">
          <span
            className={styles.placeholder}
            ref={(element) => (refPlaceholder.current[3] = element)}
          >
            Телефон
          </span>
          <input
            type="tel"
            className={styles.input}
            data-required
            id="form-tel"
            name="tel"
            placeholder=""
            ref={(element) => (refInputs.current[3] = element)}
          />
          <span
            className={styles.errortext}
            ref={(element) => (refError.current[3] = element)}
          >
            Поле обязательное
          </span>
        </label>
        <label className={styles.label} htmlFor="form-link">
          <span
            className={styles.placeholder}
            ref={(element) => (refPlaceholder.current[4] = element)}
          >
            Ссылка на резюме
          </span>
          <input
            type="text"
            className={styles.input}
            id="form-link"
            name="link"
            placeholder=""
            ref={(element) => (refInputs.current[4] = element)}
          />
        </label>

        <input
          type="file"
          className={`${styles.input} ${styles.input_file}`}
          onChange={fileHandler}
          id="file-input"
          name="link"
          accept=".pdf,.doc,.docx"
          ref={refFileInput}
          max-size="5MB"
        />
        <div className={styles.desc}>
          {!fileAdded ? (
            <>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.2445 2.14451C13.3757 1.00678 15.2181 1.00678 16.3559 2.14451C17.4936 3.28224 17.4936 5.11819 16.3559 6.25592L14.3003 8.31155C14.0481 8.56366 14.0481 8.97741 14.3003 9.22952C14.5524 9.48163 14.9596 9.48163 15.2117 9.22952L17.2738 7.17381C18.9092 5.53186 18.9092 2.86857 17.2738 1.22662C15.6318 -0.408872 12.9685 -0.408872 11.3266 1.22662L8.68908 3.87052C8.43697 4.12264 8.43697 4.52991 8.68908 4.78202C8.94119 5.03413 9.34855 5.03413 9.60066 4.78202L12.2445 2.14451Z"
                  fill="#003333"
                />
                <path
                  d="M5.15922 9.23205C5.41133 8.97994 5.41133 8.56619 5.15922 8.31408C4.90711 8.06197 4.49344 8.06197 4.24133 8.31408L1.72661 10.8287C0.0911299 12.4707 0.0911299 15.134 1.72661 16.7759C3.36856 18.4114 6.03199 18.4114 7.67394 16.7759L10.3178 14.1256C10.5699 13.8734 10.5699 13.4662 10.3178 13.2141C10.0656 12.9555 9.65845 12.9555 9.40634 13.2141L6.75589 15.858C5.61817 16.9958 3.78238 16.9958 2.64466 15.858C1.50693 14.7203 1.50693 12.878 2.64466 11.7467L5.15922 9.23205Z"
                  fill="#003333"
                />
                <path
                  d="M12.5929 6.91947C12.845 6.66736 12.845 6.25369 12.5929 6.00158C12.3408 5.74947 11.9271 5.74947 11.675 6.00158L6.50354 11.1731C6.25143 11.4252 6.25143 11.8389 6.50354 12.091C6.75565 12.3431 7.16931 12.3431 7.42142 12.091L12.5929 6.91947Z"
                  fill="#003333"
                />
              </svg>
              или
            </>
          ) : null}
          <label htmlFor="file-input" ref={refFileText}>
            прикрепите файл
          </label>
          {!fileAdded ? (
            <span> (DOC, DOCX, PDF, не более 5 МБ)</span>
          ) : (
            <span className={styles.delete} onClick={fileDeleteHandler}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    d="M10.6588 10.1216L13.641 13.1038L13.1043 13.6405L10.1221 10.6583L9.99875 10.5349L9.87542 10.6583L6.8932 13.6405L6.35653 13.1038L9.33875 10.1216L9.46208 9.99826L9.33875 9.87493L6.35653 6.89271L6.8932 6.35604L9.87542 9.33826L9.99875 9.4616L10.1221 9.33826L13.1043 6.35604L13.641 6.89271L10.6588 9.87493L10.5354 9.99826L10.6588 10.1216Z"
                    fill="#003333"
                    stroke="#003333"
                    strokeWidth="0.348837"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="19"
                    height="19"
                    rx="1.5"
                    stroke="#003333"
                  />
                </g>
              </svg>
            </span>
          )}
        </div>

        <label
          className={`${styles.label} ${styles.label_desc}`}
          htmlFor="form-add"
        >
          <span
            className={styles.placeholder}
            ref={(element) => (refPlaceholder.current[5] = element)}
          >
            Дополнительные сведения
          </span>
          <textarea
            className={styles.textarea}
            id="form-add"
            name="add"
            cols="30"
            rows="10"
            ref={(element) => (refInputs.current[5] = element)}
          ></textarea>
        </label>
        <label htmlFor="form-checkbox" className={styles.checkbox}>
          <input
            type="checkbox"
            name="checkbox"
            id="form-checkbox"
            ref={(element) => (refInputs.current[6] = element)}
          />
          <div className={styles.icon}>
            <svg
              width="13"
              height="10"
              viewBox="0 0 13 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.1288 7.89042L1.04606 4.78196L0 5.83675L4.1288 10L13 1.05479L11.9539 0L4.1288 7.89042Z"
                fill="#008359"
              />
            </svg>
          </div>
          <span>
            Я согласен на{' '}
            <a
              href="/doc/Согласие на обработку персональных данных.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              обработку персональных данных
            </a>
          </span>
        </label>
        <button type="submit" className={styles.btn} ref={refBtn}>
          Отправить
        </button>
      </form>
    </>
  );
};

export default Form;
